// Migrated from react-material-workspace-layout
// Modernized for React 19 compatibility

import BackIcon from "@mui/icons-material/KeyboardArrowLeft"
import NextIcon from "@mui/icons-material/KeyboardArrowRight"
import PlayIcon from "@mui/icons-material/PlayArrow"
import PauseIcon from "@mui/icons-material/Pause"
import SettingsIcon from "@mui/icons-material/Settings"
import HelpIcon from "@mui/icons-material/Help"
import FullscreenIcon from "@mui/icons-material/Fullscreen"
import ExitIcon from "@mui/icons-material/ExitToApp"
import QueuePlayNextIcon from "@mui/icons-material/QueuePlayNext"
import HotkeysIcon from "@mui/icons-material/Keyboard"
import WindowIcon from "@mui/icons-material/AspectRatio"

export const iconMapping = {
  back: BackIcon,
  prev: BackIcon,
  previous: BackIcon,
  next: NextIcon,
  forward: NextIcon,
  play: PlayIcon,
  pause: PauseIcon,
  settings: SettingsIcon,
  options: SettingsIcon,
  help: HelpIcon,
  fullscreen: FullscreenIcon,
  window: WindowIcon,
  exit: ExitIcon,
  quit: ExitIcon,
  save: ExitIcon,
  done: ExitIcon,
  clone: QueuePlayNextIcon,
  hotkeys: HotkeysIcon,
  shortcuts: HotkeysIcon,
}

export default iconMapping
